import React from 'react';
import { Link } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';

const BidModal = ({ isLoading, onBidPlace, onClose, placeBidAmount, totalFunds, currentBid, liveData }) => {
  return (
    <dialog id="my_modal_2" className="modal">
      <div className="modal-box dark:bg-white">
        {
          totalFunds <= 0 && (
            <div className="bg-[#e73f07e8] text-white text-center py-2 lg:py-[0.2vw]">
            <h2 className="text-md md:text-lg lg:text-20 font-semibold">
            You are almost set. Please {" "}
              <Link to={"/user/account/funds"} className="hover:text-blue-700 underline">
                add deposit
              </Link>{" "}
              to be able to bid
            </h2>
          </div>
          ) 
        }
    
        <h3 className="font-bold text-lg">Place Your bid here!</h3>
        <p className="py-4">
        Rebid allowed only if you're outbid within 24 hours. Please place your max preliminary bid to ensure winning.
        </p>
        <div className="flex gap-x-2 justify-center">
          {isLoading ? (
            <button
              className="btn text-green-600 w-[100px] dark:bg-white hover:bg-gray-200 border-green-600"
              
            >
              <ClipLoader color="#CA0000" size={20} />
            </button>
          ) : (
            <button
              className={`btn text-green-600 w-[100px] dark:bg-white hover:bg-gray-200 border-green-600 ${!placeBidAmount || placeBidAmount <= 0 || isLoading ? "bg-gray-200 text-black" : ""}`}
              onClick={onBidPlace}
              disabled={isLoading || (placeBidAmount < (currentBid || liveData) )}
            >
              Proceed
            </button>
          )}
          <button
            className="btn text-red-600 w-[100px] dark:bg-white hover:bg-gray-200 border-red-600"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default BidModal;